import { Typography } from '@mui/material';
import SelectCustom from 'Shared/Components/Form/SelectReactCustom/index';
import { IHomeTargetsOptionList } from '../../Interface/HomeTargetSupplierAssociate';
import React from 'react';

interface iProps {
  itemSelected: string;
  options: IHomeTargetsOptionList[];
  handleChange(e: any): unknown;
}

function LeadItemSelect(props: iProps) {
  return (
    <Typography component="div" align="left">
      <SelectCustom
        isDisabled={false}
        id="itemselectedlist"
        name="itemselectedlist"
        label="Selecione a filial"
        options={props.options}
        defaultValue={props.itemSelected ? props.options.find((option: IHomeTargetsOptionList) => option.value === props.itemSelected) : props.options[0]}
        onChange={props.handleChange}
      />
    </Typography>
  )
}

export default React.memo(LeadItemSelect);